"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportarForm = void 0;
var react_1 = __importStar(require("react"));
var index_css_1 = __importDefault(require("./index.css"));
var text_field_1 = require("../../ui/text-field");
var dropzone_1 = require("../dropzone");
var buttons_1 = require("../../ui/buttons");
var map_1 = require("../map");
var api_1 = require("../../lib/api");
var recoil_1 = require("recoil");
var login_1 = require("../../hooks/login");
var userData_1 = require("../../hooks/userData");
var react_router_dom_1 = require("react-router-dom");
var react_2 = require("@chakra-ui/react");
function ReportarForm() {
    var _a = (0, react_1.useState)(undefined), imageUrl = _a[0], setImageUrl = _a[1];
    var _b = (0, react_1.useState)(undefined), locationData = _b[0], setLocationData = _b[1];
    var _c = (0, react_1.useState)(false), showErrorMessage = _c[0], setShowErrorMessage = _c[1];
    var _d = (0, react_1.useState)(false), showLoadingSubmit = _d[0], setShowLoadingSubmit = _d[1];
    var tokenValue = (0, recoil_1.useRecoilValue)(login_1.token);
    var userDataValue = (0, recoil_1.useRecoilValue)(userData_1.userData);
    var navigate = (0, react_router_dom_1.useNavigate)();
    function preventKeyDown(e) {
        if (e.key == "Enter") {
            e.preventDefault();
            return;
        }
    }
    function formHandler(e) {
        e.preventDefault();
        setShowErrorMessage(false);
        setShowLoadingSubmit(true);
        var allData = {
            imageUrl: imageUrl,
            locationData: locationData,
            nombre: e.target.nombre.value,
        };
        for (var property in allData) {
            if (!allData[property]) {
                setShowErrorMessage(true);
                setShowLoadingSubmit(false);
                return;
            }
        }
        var petData = {
            imageUrl: allData.imageUrl,
            lat: allData.locationData.lat,
            lng: allData.locationData.lng,
            city: allData.locationData.city,
            region: allData.locationData.region,
            name: allData.nombre,
            contact: userDataValue.email,
        };
        (0, api_1.postNuevaMascota)(petData, tokenValue).then(function (res) {
            setShowLoadingSubmit(false);
            navigate("/mis-mascotas");
        });
    }
    return (react_1.default.createElement("form", { onKeyDown: preventKeyDown, onSubmit: formHandler, className: index_css_1.default.container },
        showLoadingSubmit && (react_1.default.createElement("div", { className: index_css_1.default["loading-submit"] },
            react_1.default.createElement(react_2.Spinner, { size: "xl", zIndex: "5" }))),
        react_1.default.createElement(text_field_1.TextField, { maxLength: 11, autoFocus: true, autoComplete: "off", label: "NOMBRE", name: "nombre", type: "text" }),
        react_1.default.createElement(dropzone_1.DropzoneForm, { cb: setImageUrl }),
        react_1.default.createElement(map_1.Map, { cb: setLocationData }),
        showErrorMessage && (react_1.default.createElement("p", { className: index_css_1.default["error-message"] }, "Los campos no pueden quedar vacios")),
        react_1.default.createElement(buttons_1.MainButton, { type: "submit", color: "pink" }, "Reportar como perdido"),
        react_1.default.createElement(buttons_1.MainButton, { onClick: function () {
                navigate("/");
            }, type: "button", color: "gray" }, "Cancelar")));
}
exports.ReportarForm = ReportarForm;
